import React from 'react'
import { Bar } from 'react-chartjs-2'

const CherriesProcessedChart = ({ cherriesProcessedByTime = [] }) => {
  const labels = cherriesProcessedByTime.map((item) => item.label)

  const data = {
    labels,
    datasets: [
      {
        label: 'Total',
        type: 'line',
        data: cherriesProcessedByTime.map((item) => item.total),
        borderColor: '#215f9a',
        backgroundColor: 'transparent',
        borderWidth: 3,
        pointBackgroundColor: '#215f9a',
        pointBorderColor: '#fff',
        pointBorderWidth: 2,
        pointRadius: 6,
        tension: 0.1,
        fill: false,
      },
      {
        label: 'Major Defect',
        data: cherriesProcessedByTime.map((item) => item.majorDefect),
        backgroundColor: '#c1e5f5',
        borderWidth: 0,
        stack: 'Defect',
      },
      {
        label: 'Minor Defect',
        data: cherriesProcessedByTime.map((item) => item.minorDefect),
        backgroundColor: '#d9d9d9',
        borderWidth: 0,
        stack: 'Defect',
      },
    ],
  }

  const options = {
    maintainAspectRatio: false,
    responsive: true,
    legend: {
      display: true,
      position: 'top',
      align: 'end',
      fullWidth: false,
    },
    tooltips: {
      mode: 'index',
      intersect: false,
      callbacks: {
        title: (tooltipItem, data) => {
          return data.labels[tooltipItem[0].index]
        },
        label: (tooltipItem, data) => {
          const datasetLabel = data.datasets[tooltipItem.datasetIndex].label
          const value = tooltipItem.yLabel
          return `${datasetLabel}: ${value}`
        },
      },
    },
    title: {
      display: true,
      text: 'Cherries Processed By Time',
      fontSize: 20,
      fontColor: '#2a496c',
      fontWeight: 600,
    },
  }

  return <Bar options={options} data={data} />
}

export default CherriesProcessedChart
